export enum Authentication {
  BasicAuthentication =1,
  NoAuthentication = 2
}

export enum Environments {
  dev,
  test,
  prod
}

export enum HTTPMethod {
  GET,
  'GET ALL',
  CREATE,
  UPDATE,
  DELETE
}
